import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/theme-provider';
import { LanguageProvider } from './context/language-context';
import RootLayout from './layouts/RootLayout';
import ProtectedRoute from './components/protected-route';

// Import pages
import HomePage from './pages/Home';
import LoginPage from './pages/Login';
import AccountPage from './pages/Account';
import CarDeliveryPage from './pages/CarDelivery';
import EstablishmentDetailPage from './pages/EstablishmentDetail';
import InspectionsPage from './pages/Inspections';
import InspectionQuestionnairePage from './pages/InspectionQuestionnairePage';
import LaborMarketPage from './pages/LaborMarket';
import LegislationPage from './pages/Legislation';
import MapPage from './pages/Map';
import MapViewPage from './pages/MapView';
import MenuPage from './pages/Menu';
import MyDataPage from './pages/MyData';
import NotificationsPage from './pages/Notifications';
import OfficePolicyPage from './pages/OfficePolicy';
import PerformancePage from './pages/Performance';
import PlanPage from './pages/Plan';
import Schedule from './pages/Schedule';
import PlanningPage from './pages/Planning';
import RecruitmentPage from './pages/Recruitment';
import ReportsPage from './pages/Reports';
import SendNotePage from './pages/SendNote';
import ServicesPage from './pages/Services';
import TestPage from './pages/Test';
import TrackPage from './pages/Track';
import SuggestedInspectionsPage from './pages/SuggestedInspections';
import RouteOptimizationPage from './pages/RouteOptimization';
import TestToastPage from './pages/TestToast';
import VisitSummaryDemoPage from './pages/VisitSummaryDemo';
import MapUrbiPage from './pages/MapUrbi';

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <LanguageProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<RootLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route
                path="/car-delivery"
                element={<CarDeliveryPage />}
              />
              <Route
                path="/establishment/:id"
                element={<EstablishmentDetailPage />}
              />
              <Route
                path="/establishment/:id/questionnaire"
                element={<InspectionQuestionnairePage />}
              />
              <Route
                path="/inspections"
                element={<InspectionsPage />}
              />
              <Route
                path="/labor-market"
                element={<LaborMarketPage />}
              />
              <Route
                path="/legislation"
                element={<LegislationPage />}
              />
              <Route path="/map" element={<MapPage />} />
              <Route path="/map-view" element={<MapViewPage />} />
              <Route path="/map-urbi" element={<MapUrbiPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/my-data" element={<MyDataPage />} />
              <Route
                path="/notifications"
                element={<NotificationsPage />}
              />
              <Route
                path="/office-policy"
                element={<OfficePolicyPage />}
              />
              <Route
                path="/performance"
                element={<PerformancePage />}
              />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/plan" element={ <MapPage /> } />
              {/* <Route path="/plan" element={<PlanPage />} /> */}
              <Route path="/suggested-inspections" element={<SuggestedInspectionsPage />} />
              <Route path="/route-optimization" element={<RouteOptimizationPage />} />
              <Route path="/planning" element={<PlanningPage />} />
              <Route
                path="/recruitment"
                element={<RecruitmentPage />}
              />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/send-note" element={<SendNotePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/test" element={<TestPage />} />
              <Route path="/test-toast" element={<TestToastPage />} />
              <Route path="/track" element={<TrackPage />} />
              <Route path="/visit-summary-demo" element={<VisitSummaryDemoPage />} />
            </Route>
          </Route>

          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
